import { render, staticRenderFns } from "./mergeCases.vue?vue&type=template&id=d1ac9120"
import script from "./mergeCases.vue?vue&type=script&lang=js"
export * from "./mergeCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports